import React from 'react';
import { KatBox, KatSpinner } from '@amzn/katal-react';
import { useWhereIsMyStringQuery } from 'src/generated/graphql';
import ErrorHandler from 'src/components/common/ui/ErrorHandler/ErrorHandler';
import initialMetricsPublisher from 'src/metrics';
import styles from './WhereIsMyString.module.scss';

const metricPublisher: any =
  initialMetricsPublisher.newChildActionPublisherForMethod('WhereIsMyString');

type Props = Record<string, never>;

const WhereIsMyString: React.FC<Props> = (props: Props) => {
  // Dummy data for testing the whereIsMyString query
  const dummyParams = {
    contentId: 'test-content-id-123',
    locale: 'en_US',
    marketplace: 'US',
  };

  const { data, loading, error } = useWhereIsMyStringQuery({
    variables: {
      params: dummyParams,
    },
    errorPolicy: 'all',
  });

  if (loading) {
    return (
      <div className={styles.wimsContainer}>
        <KatBox variant="white">
          <KatSpinner />
        </KatBox>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.wimsContainer}>
        <ErrorHandler
          publisher={metricPublisher}
          header="Error loading Where Is My String data"
          error={error}
        />
      </div>
    );
  }

  return (
    <div className={styles.wimsContainer}>
      <KatBox variant="white" className={styles.wimsBox}>
        <h1>Where Is My String - Raw Results</h1>

        <div className={styles.wimsSection}>
          <h2>Query Parameters (Dummy Data)</h2>
          <KatBox variant="nordic" className={styles.wimsCodeBlock}>
            <pre>{JSON.stringify(dummyParams, null, 2)}</pre>
          </KatBox>
        </div>

        {data && (
          <div className={styles.wimsSection}>
            <h2>Raw Response Data</h2>
            <KatBox variant="nordic" className={styles.wimsCodeBlock}>
              <pre>{JSON.stringify(data, null, 2)}</pre>
            </KatBox>
          </div>
        )}

        {!data && !error && (
          <div className={styles.wimsSection}>
            <p>No data received from the query.</p>
          </div>
        )}
      </KatBox>
    </div>
  );
};

export default WhereIsMyString;
